async function createProfile () {
  
  const webhookUrl = 'https://hooks.zapier.com/hooks/catch/23394575/uobdecp/';
  const email = document.getElementById('checkEmail').value;

  const emailCheck = validateEmail(email);

  const formData = new FormData();
  formData.append('email', email);

  if (emailCheck) {


      try {
    const response = await fetch(webhookUrl, {
      method: 'POST',
      body: formData // GEEN headers instellen
    });

    if (response.ok) {
      // alert('E-mail succesvol verzonden!');
      // document.getElementById('checkEmail').value = '';
      window.location.href = '/collections';
    } else {
      // alert('Er ging iets mis bij het verzenden.');
    }
  } catch (error) {
    // alert('Fout bij verbinding met Zapier.');
    console.error(error);
  }


    
  } else {
    console.log('Email is fout');
  }


}

function validateEmail(email) {
  var re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return re.test(email);
}